import styled from 'styled-components';

const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr;
  gap: 20px;
  width: 100vw;
`;

export default Content;
